
import { visitorService } from "@/service";
import { reactive, ref } from "vue";
import { defineComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Toast } from "vant";
import approver from "./components/approver.vue";
import { RouterName } from "@/router";
import Clipboard from "clipboard";
import { DetailBlockItem, DetailItem } from "@/components/DetailView/index";
import { FooterButton } from "@/components/FormView/index";

export default defineComponent({
  components: {
    approver,
    DetailBlockItem,
    DetailItem,
    FooterButton
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const detail = reactive<any>({});

    const getDetail = async () => {
      try {
        const { data } = await visitorService.visitorDetail(route.query.id as string);
        const opt_lists =
          data.data?.opt_list && data.data?.opt_list.length
            ? data.data.opt_lists.filter((i: any) => i.type == "2" || i.type == "1")
            : [];
        Object.assign(detail, { ...data.data, opt_lists });
      } catch {
        // error
      }
    };
    getDetail();
    const handleClick = (type: string) => {
      router.push({
        name: RouterName.VISITOR_RESULT,
        query: {
          type: type,
          visitor_token: detail.visitor_token,
          id: detail.id
        }
      });
    };
    const copyText = ref("");
    const copyCurrentUrl = async () => {
      // const u = navigator.userAgent;
      // const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      // navigator.clipboard.writeText(`${window.location.origin}/visitor/ownerVisitors?h5_code=${detail.h5_code}`);
      // Toast.success("复制成功");

      copyText.value = detail.h5_code;
      const clipboard = new Clipboard(".copy-view");
      clipboard.on("success", () => {
        Toast.success("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        Toast.success("复制成功");
        clipboard.destroy();
      });
    };

    const show = ref(false);
    return {
      show,
      detail,
      copyText,
      handleClick,
      copyCurrentUrl
    };
  }
});
